/* Nilya menüleri:
   1) Masaüstü (>=990px, fare/dokunmatik olmayan): açılır alt menüler hover ile açılır, tıklama gerekmez.
      Klavye (Enter/Space) ve dokunmatik ekran eskisi gibi tıklamayla çalışır.
   2) Mobil çekmece: alt menüler ayrı sayfaya kaymaz, açılır/kapanır (accordion). */
(function () {
  var hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover)');

  function initHover() {
    var menu = document.querySelector('.header__inline-menu');
    if (!menu || menu.dataset.nilyaHover) return;
    menu.dataset.nilyaHover = 'true';
    var timers = new WeakMap();

    menu.querySelectorAll('header-menu > details').forEach(function (details) {
      var summary = details.querySelector('summary');
      details.addEventListener('mouseenter', function () {
        if (!hoverQuery.matches) return;
        clearTimeout(timers.get(details));
        menu.querySelectorAll('header-menu > details[open]').forEach(function (other) { if (other !== details) other.removeAttribute('open'); });
        details.setAttribute('open', '');
      });
      details.addEventListener('mouseleave', function () {
        if (!hoverQuery.matches) return;
        timers.set(details, setTimeout(function () { details.removeAttribute('open'); }, 160));
      });
      // Fare tıklaması açık menüyü kapatmasın; klavye (detail === 0) normal çalışır
      summary.addEventListener('click', function (event) {
        if (hoverQuery.matches && event.detail > 0) event.preventDefault();
      });
    });
  }

  function initAccordions() {
    document.querySelectorAll('.nilya-accordion__toggle').forEach(function (toggle) {
      if (toggle.dataset.nilyaAccordion) return;
      toggle.dataset.nilyaAccordion = 'true';
      function toggleAccordion() {
        var panel = document.getElementById(toggle.getAttribute('aria-controls'));
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        if (panel) panel.hidden = open;
      }
      toggle.addEventListener('click', toggleAccordion);
      toggle.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggleAccordion(); }
      });
    });
  }

  function init() { initHover(); initAccordions(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
